// extracted by mini-css-extract-plugin
module.exports = {"actions":"payment-summary_actions__3ciHR"};